import React, {Component} from 'react';
import {peopleThumbHeights, productThumbHeights, personalThumbHeights} from '../imagesInfo.js';

let picWidth = 200;
let navWidth = 289;
let percWidth = 0.85;


export default class MasonryGrid extends Component {
  constructor(props) {
		super(props);

		this.state = {
      width: (window.innerWidth-navWidth)*percWidth,
      columns: 1
    };

		this.onResize = this.onResize.bind(this);
    this.heights = this.getHeights(props.type);
	}


	componentDidMount() {
		this.onResize();
		window.addEventListener('resize', this.onResize);
	}

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

	getColumns(w) {
    return Math.max(1, Math.floor(w/picWidth));
	}

  getHeights(type) {
    switch(type) {
      case '/work/people':
        return peopleThumbHeights;
      case '/work/products':
        return productThumbHeights;
      case '/work/personal':
        return personalThumbHeights;
      default:
        return peopleThumbHeights;
    }
  }

	onResize() {
		let columns = 3;
    let w = (window.innerWidth-navWidth)*percWidth;
    let width = this.state.width;

    try {
      columns = this.getColumns(w);
      let numNormalCols = Math.floor(w/picWidth);
      width = Math.floor(w/picWidth)*picWidth;

      if (width <= 0) {
        width = w;
      }
    }
    catch(err) {
      console.log('error getting window size');
    }

		if(columns !== this.state.columns){
			this.setState({columns: columns});
		}

    if (width !== this.state.width) {
      this.setState({width: width});
    }
    // console.log('')
	}

	mapChildren() {
		let col = [];
    let colHeights = [];
		const numC = this.state.columns;

		for(let i = 0; i < numC; i++){
			col.push([]);
      colHeights.push(0);
		}

		return this.props.children.reduce((p,c,i) => {
      let index = this.indexOfMin(colHeights);
      colHeights[index] += this.heights[i];
			p[index].push(c);
			return p;
		}, col);
	}

  indexOfMin(arr) {
    let l = arr.length;

    if (l === 0) {
      console.log("error getting column min")
      return 0;
    }

    let min = arr[0];
    let minIndex = 0;

    for (let i = 1; i < l; i++) {
      if (arr[i] < min) {
        min = arr[i];
        minIndex = i;
      }
    }

    return minIndex;
  }

	render() {
    let widthStyle = {
      width: this.state.width
    }

		return (
			<div className='masonry' style={widthStyle}>
				{this.mapChildren().map((col, ci) => {
					return (
						<div className='masonry-column' key={ci} >
							{col.map((child, i) => {
								return <div key={i} >{child}</div>
							})}
						</div>
					)
				})}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/MasonryGrid.js